import { DesignLogo } from "../../../../core/models/entities/Design";

export function hasUnsavedChanges(
  original: DesignLogo[],
  current: DesignLogo[]
): boolean {
  if (original.length !== current.length) {
    return true;
  }

  // Create a map of original logos by inDesignId for faster lookup
  const originalMap = new Map(original.map((l) => [l.inDesignId, l]));

  for (const currentLogo of current) {
    const originalLogo = originalMap.get(currentLogo.inDesignId);
    if (!originalLogo) {
      return true; // New logo added
    }

    if (areLogosDifferent(originalLogo, currentLogo)) {
      return true;
    }
  }

  return false;
}

function areLogosDifferent(a: DesignLogo, b: DesignLogo): boolean {
  // Compare fields that affect the design
  const epsilon = 0.0001;

  if (Math.abs(a.logoX - b.logoX) > epsilon) {
    return true;
  }
  if (Math.abs(a.logoY - b.logoY) > epsilon) {
    return true;
  }
  if (Math.abs(a.angleRads - b.angleRads) > epsilon) {
    return true;
  }

  // We are NOT checking heightMm, widthMm, viewId, etc. as per user instruction.
  // "The only things we need to check for is firstly the logos on the design; Are there any new logos? Have the user removed any logos from the design?
  // And then secondly; Have any logos been moved (angleRads, logoX and logoY)?"

  return false;
}
